<template>
  <a
    class="share-button xing-share-button"
    :href="shareUrl"
    target="_blank"
    @click="firePropTrackAction()"
  >
    <img
      style="width: 30px; height: auto"
      src="@/assets/images/share-xing.png"
    />
  </a>
</template>

<script>
export default {
  computed: {
    shareUrl() {
      const url = encodeURIComponent("https://topjobs.xing.com/");
      return `https://www.xing.com/spi/shares/new?url=${url}`;
    },
  },
  methods: {
    firePropTrackAction() {
      const trackingParams = {
        PropTrackAction: "jobs_topjobs_social_share",
        PropActionOrigin: "jobs_topjobs_social_share_xing",
      };
      window.ttt.event("PropTrackAction", trackingParams);
      console.log("propTrackAction", trackingParams);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/share-button.scss";

.xing-share-button {
  & img {
    transform: scale(2.5);
  }
}
</style>
